export default {"src":"/_next/static/media/wan.8d207afc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};